// // This file can be replaced during build by using the `fileReplacements` array.
// // `ng build` replaces `environment.ts` with `environment.prod.ts`.
// // The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   firebaseConfig : {
//     apiKey: "AIzaSyDrq4sHSaQBO-NxLj0OHqXjB4miKKIiI2c",
//     authDomain: "afrimart-fb9f8.firebaseapp.com",
//     projectId: "afrimart-fb9f8",
//     storageBucket: "afrimart-fb9f8.appspot.com",
//     messagingSenderId: "134224577769",
//     appId: "1:134224577769:web:6107c208cb2db15e195c78",
//     measurementId: "G-7MSVE2960V"
//   },
//   prefix: 'dev_',
//   mapKey:"AIzaSyBBEynhMRGDVyWfyOPZ6FBMWcJwxHM3zGI",
//   vapidKey:"BCLBt6Zc-ILacU0BiPSultaZMkm-w9laMkdQOS0xfZiZ-J6EwmhOi9PKNBGtRszaNlq-GNiVQFnC8HDz8Jay26k",
//   api:'https://ruecart-ca-vendor-dev-134224577769.us-central1.run.app/',
//   clientApi:"https://ruecart-ca-client-ms-dev-134224577769.us-central1.run.app/",
//   STRIPE_PK:'pk_test_51R9WR1CVfNGLn7duQrYBYD4axwYcacxNVAXemmjFWWIDXqFLNFG3HELHfWyaZmKVLgKoM2fcFSyxbmTao2f2ToRE00jxHhvxKe',
//   collections:{
//     VENDOR: 'vendor',  // Collection for vendor
//     PRODUCTS: 'products',  // Collection for product
//     SERVICES: 'services',  //Collection for services
//     LISTINGS: 'listings', //Listing for product and services
//     CLIENT:'client',      //Collection for client user
//     ORDER:'raw_order',     //Collection for order
//     VENDOR_ORDER:'vendor_order',
//     VENDOR_SERVICE_ORDER:'vendor_service_order',
//     FORM_FIELDS:'dev_form_fields',
//     EVENTS:'events',
//     TICKETS:'tickets',
//     REVIEWS:'reviews'

//   },
//   endpoints:{
//     CLIENT:'client',      //Endpoint  for client user profile - (creation, etc)
//     PHONE:'client/phone', //For phone login profile creation
//     CHECK_EMAIL:'client/check-email',
//     ORDER:'order',        //Endpoint for submitting/creating a new order to backend
//     SERVICE_ORDER:'order/service',  //Endpoint for booking service
//     MESSAGING:'order/messaging',  //Endpoint for sending messaging
//     SERVICES_MESSAGING: 'service/messaging',   //endpoint for services messaging

//     UPDATE_TOKEN:'order/messaging/register-token',
//     SEARCH_PRODUCT:'search-products',
//     SEARCH_SERVICE:'search-products/services',
//     TOP_DEAL_PRODUCT:'top-deals',
//     TOP_DEAL_SERVICES: 'top-deals/services',
//     ALL_PRODUCTS: 'top-deals/all-products',
//     ALL_SERVICES: 'top-deals/all-services',
//     CREATE_VENDOR:'https://smedan-vendor-dev.web.app',
//     SEND_FEEDBACK:'feedback',
//     INITIATE_BVN: 'create_baines_client/initiate-bvn-validation',
//     BVN_VALIDATION: 'create_baines_client/bvn-otp-validation',
//     QUERY_BANK_CUSTOMER: 'create_baines_client/existing-bank-customer', //Query Baines Existing bank customer
//     REVIEW:'review',
//     EVENT:'event',
//     CHECKOUT_SESSION:'create-checkout-session',
//     VENDOR_AVAILABILITY_NOTIFICATION:'trigger-availability-email'

//   }
// };

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyBT685mSVwiNrXRY13SXhz-fMi-Th-iRmw",
    authDomain: "ruecart-smedan-ng.firebaseapp.com",
    databaseURL: "https://ruecart-smedan-ng-default-rtdb.firebaseio.com",
    projectId: "ruecart-smedan-ng",
    storageBucket: "ruecart-smedan-ng.firebasestorage.app",
    messagingSenderId: "639143691873",
    appId: "1:639143691873:web:f21cb9d896951515978c20",
    measurementId: "G-YC3RFC5L9N"
  },
  prefix: 'dev_',
  mapKey:"AIzaSyC1xeGwc7fUw37_z9E3-u5w-iZKC8MPdPY",
  vapidKey:"BCLBt6Zc-ILacU0BiPSultaZMkm-w9laMkdQOS0xfZiZ-J6EwmhOi9PKNBGtRszaNlq-GNiVQFnC8HDz8Jay26k",
  api:'https://ruecart-smedan-vendor-dev-ms-639143691873.us-central1.run.app/',
  clientApi:"https://ruecart-smedan-client-ms-dev-639143691873.us-central1.run.app/",
  STRIPE_PK:'pk_test_51R9WR1CVfNGLn7duQrYBYD4axwYcacxNVAXemmjFWWIDXqFLNFG3HELHfWyaZmKVLgKoM2fcFSyxbmTao2f2ToRE00jxHhvxKe',
  collections:{
    VENDOR: 'vendor',  // Collection for vendor
    PRODUCTS: 'products',  // Collection for product
    SERVICES: 'services',  //Collection for services
    LISTINGS: 'listings', //Listing for product and services
    CLIENT:'client',      //Collection for client user
    ORDER:'raw_order',     //Collection for order
    VENDOR_ORDER:'vendor_order',
    VENDOR_SERVICE_ORDER:'vendor_service_order',
    FORM_FIELDS:'dev_form_fields',
    EVENTS:'events',
    TICKETS:'tickets',
    REVIEWS:'reviews'

  },
  endpoints:{
    CLIENT:'client',      //Endpoint  for client user profile - (creation, etc)
    PHONE:'client/phone', //For phone login profile creation
    CHECK_EMAIL:'client/check-email',
    ORDER:'order',        //Endpoint for submitting/creating a new order to backend
    SERVICE_ORDER:'order/service',  //Endpoint for booking service
    MESSAGING:'order/messaging',  //Endpoint for sending messaging
    SERVICES_MESSAGING: 'service/messaging',   //endpoint for services messaging

    UPDATE_TOKEN:'order/messaging/register-token',
    SEARCH_PRODUCT:'search-products',
    SEARCH_SERVICE:'search-products/services',
    TOP_DEAL_PRODUCT:'top-deals',
    TOP_DEAL_SERVICES: 'top-deals/services',
    ALL_PRODUCTS: 'top-deals/all-products',
    ALL_SERVICES: 'top-deals/all-services',
    CREATE_VENDOR:'https://sme-dev.ruecart.com',
    SEND_FEEDBACK:'feedback',
    INITIATE_BVN: 'create_baines_client/initiate-bvn-validation',
    BVN_VALIDATION: 'create_baines_client/bvn-otp-validation',
    QUERY_BANK_CUSTOMER: 'create_baines_client/existing-bank-customer', //Query Baines Existing bank customer
    REVIEW:'review',
    EVENT:'event',
    CHECKOUT_SESSION:'create-checkout-session',
    VENDOR_AVAILABILITY_NOTIFICATION:'trigger-availability-email',
    UPDATES: 'updates'

  }
};



